import _ from 'underscore';
import React from 'react';
import { Activity, Message } from 'botframework-directlinejs';
import { AIMessage, PluginFunctions, PluginScenarios } from '@bingads-webui/ads-copilot-ui';
import { type ActivityRenderer } from '@bingads-webui-react/msa-copilot-common';

import { InsightsSummarizeMessage } from '../insights-summarize-message';
import { InsightsMissingParams } from '../insights-missing-params';

export const SummarizePluginRenderer: ActivityRenderer = (props) => {
  const {
    activity,
    getCampaigns,
    logger,
    onFeedbackButtonClick,
    onMissingParamsSubmit,
    isCustomizedEventBusy,
    isReportingInsights15Enabled,
  } = props;

  if (activity.type === 'event') {
    if (_.any(activity.value, (pluginResult) => pluginResult.Status === 'MissingParameters')) {
      return (
        <InsightsMissingParams
          getCampaigns={getCampaigns}
          logger={logger}
          replyToId={(activity as any).replyToId}
          onMissingParamsSubmit={onMissingParamsSubmit}
          pluginName={PluginScenarios.Summarize}
        />
      );
    }
    // don't render the plugin results as a separate card
    return null;
  }

  return (
    <AIMessage
      className="summarize-plugin-renderer"
      message={activity as Message}
      onFeedbackButtonClick={onFeedbackButtonClick}
      showDataDisclaimer
    >
      <InsightsSummarizeMessage
        logger={logger}
        replyToId={(activity as any).replyToId}
        isCustomizedEventBusy={isCustomizedEventBusy}
        isReportingInsights15Enabled={isReportingInsights15Enabled}
      />
    </AIMessage>
  );
};

SummarizePluginRenderer.canRender = (activity: Activity) => {
  if (activity.type === 'message') {
    // only render message if the summarize plugin was successfully invoked by the AI
    return _.any((activity.value as any)?.Features, (feature) => feature === PluginFunctions.SummarizeCampaignPerformance);
  }

  if (activity.type === 'event' && activity.name === 'pluginResults') {
    return _.any(activity.value, (pluginResult) => pluginResult.Name === PluginScenarios.Summarize);
  }

  return false;
};
